;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputToggleSelector', inputToggleSelector)

  /* @ngInject */
  function inputToggleSelector () {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        model: '=',
        options: '=',
        disabled: '<'
      },
      templateUrl: '/core/directives/input-toggle-selector/input-toggle-selector-directive.html?$$REVISION$$',
      controller: 'InputToggleSelectorController'
    }
  }
})()
